import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function MonthlyAttendanceKPICards({ metrics }) {
  const navigate = useNavigate();

  const present = metrics?.present ?? metrics?.TotalPresent ?? 0;
  const absent = metrics?.absent ?? metrics?.TotalAbsent ?? 0;
  const lateMarks = metrics?.lateMarks ?? metrics?.TotalLateMarks ?? 0;
  const leaves = metrics?.leaves ?? metrics?.TotalLeaves ?? 0;

  const cards = [
    {
      id: 'present',
      title: 'Present Days',
      count: present,
      icon: 'check_circle',
      color: 'text-emerald-700',
      bg: 'bg-emerald-500/10',
      border: 'border-emerald-500/20',
      tag: 'On Duty',
    },
    {
      id: 'absent',
      title: 'Absent Days',
      count: absent,
      icon: 'cancel',
      color: 'text-rose-700',
      bg: 'bg-rose-500/10',
      border: 'border-rose-500/20',
      tag: 'Unapproved',
    },
    {
      id: 'late',
      title: 'Late Marks',
      count: lateMarks,
      icon: 'alarm',
      color: 'text-amber-700',
      bg: 'bg-amber-500/10',
      border: 'border-amber-500/20',
      tag: 'Grace Used',
    },
    {
      id: 'leaves',
      title: 'Leaves Taken',
      count: leaves,
      icon: 'time_to_leave',
      color: 'text-indigo-700',
      bg: 'bg-indigo-500/10',
      border: 'border-indigo-500/20',
      tag: 'Approved',
    },
  ];

  const currentMonthName = new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-wider text-black">
            Monthly Attendance Overview
          </h3>
          <p className="text-[11px] text-slate-500 font-medium">
            Calculated for {currentMonthName} directly from biometric records
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/self-service/attendance-history')}
          className="text-xs font-bold text-primary hover:underline inline-flex items-center gap-1 cursor-pointer"
        >
          <span>Detailed Log</span>
          <span className="material-symbols-outlined text-sm">open_in_new</span>
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {cards.map((card) => (
          <div
            key={card.id}
            onClick={() => navigate('/self-service/attendance-history')}
            className={`group relative overflow-hidden rounded-2xl border ${card.border} bg-surface p-4 shadow-xs transition hover:shadow-sm hover:scale-[1.01] cursor-pointer`}
          >
            <div className="flex items-center justify-between">
              <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
                <span className="material-symbols-outlined text-xl">{card.icon}</span>
              </div>
              <span className="text-[10px] font-bold rounded-md bg-surface-container-high px-2 py-0.5 text-slate-600">
                {card.tag}
              </span>
            </div>

            <div className="mt-3">
              <span className="font-mono text-2xl sm:text-3xl font-extrabold text-on-surface">
                {card.count}
              </span>
              <p className="text-xs font-semibold text-slate-600 mt-0.5">{card.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
